<template>
  <div class="my-5 text-light">
    <div class="container">
      <div class="text-center">
        <h1 class="page-h1">{{ initialTitle }}</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(["initialTitle"]),
  },
};
</script>
